import { useTranslation } from 'react-i18next';

import { Avatar, AvatarGroup } from '../Avatar';
import * as Styled from './HeroCard.styles';

const HeroCard = ({ card }) => {
  const { t } = useTranslation();
  const { title, text, user, postedIn, decorAvatars } = card;

  return (
    <Styled.Card className="glass-border">
      {user?.name && (
        <Styled.User>
          <Avatar src={user.src} alt={user.alt} />
          <Styled.Name variant="body16">{user.name}</Styled.Name>
        </Styled.User>
      )}

      {postedIn && (
        <Styled.PostedIn>
          <Styled.PostedInLabel variant="body14">
            {t('homeHero.postedInLabel')}
          </Styled.PostedInLabel>

          <Avatar icon="users" size="sm" />
          <Styled.PostedInText variant="body14">{postedIn}</Styled.PostedInText>
        </Styled.PostedIn>
      )}

      {decorAvatars.length > 0 && (
        <AvatarGroup>
          {decorAvatars.map((decor) => (
            <Avatar key={decor.icon} {...decor} />
          ))}
        </AvatarGroup>
      )}

      <Styled.Title variant="h5">{title}</Styled.Title>
      <Styled.Text variant="body16">{text}</Styled.Text>
    </Styled.Card>
  );
};

export default HeroCard;
